module.exports = __webpack_public_path__ + "static/media/skill12.f63d4fda.jpeg";